import { toNumber } from '../../../utils/Utils';
import { RESULTADOS_KEY_ORDER, ResultadosRow, BuildResultadosRowsV1Args } from './types';

// V1 (legacy): usa el merge por índice del DataTable (mantener comportamiento previo)
export function buildResultadosRowsV1({
  getMergedValues,
  getTranslation,
  previousTotals,
  currentTotals,
  isResultadoBrutoFiltered = false,
}: BuildResultadosRowsV1Args): ResultadosRow[] {
  const rows: ResultadosRow[] = [];

  (['gross_result', 'operating_result', 'ordinary_result'] as const).forEach((cat) => {
    const sectionLabels: Record<string, string> = {
      gross_result: 'Resultado bruto',
      operating_result: 'Resultado operativo',
      ordinary_result: 'Resultado ordinario',
    };
    const order = RESULTADOS_KEY_ORDER[cat];
    const merged = getMergedValues(cat);
    let ordered = order ? [...merged].sort((a, b) => order.indexOf(a.label) - order.indexOf(b.label)) : merged;
    
    // Filtrar campos de Resultado Bruto si está habilitado
    if (cat === 'gross_result' && isResultadoBrutoFiltered) {
      ordered = ordered.filter(
        (r) => r.label !== 'agricultural_production' && r.label !== 'production_cost'
      );
    }

    ordered.forEach((r) => {
      rows.push({
        label: getTranslation(cat, r.label),
        valuePrev: r.valuePrev,
        valueCurr: r.valueCurr,
        isBold: false,
      });
    });

    rows.push({
      label: sectionLabels[cat],
      valuePrev: previousTotals?.[cat] ?? 0,
      valueCurr: currentTotals?.[cat] ?? 0,
      isBold: true,
    });
  });

  rows.push({
    label: 'Ingresos extraordinarios',
    valuePrev: (previousTotals?.result_before_taxes as any)?.extraordinary_income ?? 0,
    valueCurr: (currentTotals?.result_before_taxes as any)?.extraordinary_income ?? 0,
    isBold: false,
  });
  rows.push({
    label: 'Egresos extraordinarios',
    valuePrev: (previousTotals?.result_before_taxes as any)?.extraordinary_expenses ?? 0,
    valueCurr: (currentTotals?.result_before_taxes as any)?.extraordinary_expenses ?? 0,
    isBold: false,
  });
  rows.push({
    label: 'Resultado antes de impuestos',
    valuePrev: (previousTotals?.result_before_taxes as any)?.total ?? previousTotals?.result_before_taxes ?? 0,
    valueCurr: (currentTotals?.result_before_taxes as any)?.total ?? currentTotals?.result_before_taxes ?? 0,
    isBold: true,
  });
  rows.push({
    label: 'Impuesto a las ganancias',
    valuePrev: toNumber(previousTotals?.income_tax_formatted),
    valueCurr: toNumber(currentTotals?.income_tax_formatted),
    isBold: false,
  });
  rows.push({
    label: 'Resultado del ejercicio',
    valuePrev: toNumber(previousTotals?.taxes),
    valueCurr: toNumber(currentTotals?.taxes),
    isBold: true,
  });

  return rows;
}

